export default "assets/images/gold-texture-ac015cd2.jpg";